module.exports = __webpack_public_path__ + "img/csc_1.48e54e8b.gif";